import script from "./ImagePanelUI.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImagePanelUI.vue?vue&type=script&setup=true&lang=ts"

import "./ImagePanelUI.vue?vue&type=style&index=0&id=4ff9ced8&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff9ced8"]])

export default __exports__